import styled from 'styled-components';
import AffordabilityIcon from '../../../../new-components/svg-icons/AffordabilityIcon';
import { useTranslation } from 'next-i18next';
import { useEffect, useState } from 'react';
import AffordabilityStepper from './AffordabilityStepper';
import LongArrowIcon from '../../../../new-components/svg-icons/LongArrow';
import { useRouter } from 'next/router';
import { logEvent } from '../../../../new-lib/analytics';

const AffordabilityBanner = () => {
  const { t } = useTranslation('search');
  const { locale, ...router } = useRouter();
  const [stepper, setStepper] = useState(false);
  const { query } = router;

  const handleBannerClick = () => {
    setStepper(true);
    logEvent.click('AffCalc_click', 'search_page', 'Aff_banner');
  };

  useEffect(() => {
    if (query.affordability === 'true') setStepper(true);
  }, []);

  return (
    <>
      <Container onClick={handleBannerClick} locale={locale}>
        <AffordabilityIcon />
        <div className="banner">
          <span className="banner-title">
            {t('affordability_banner_title')}
          </span>
          <span className="banner-subtitle">
            {t('affordability_banner_subtitle')}{' '}
            <LongArrowIcon fill="#404751" />
          </span>
        </div>
      </Container>
      {stepper && (
        <AffordabilityStepper stepper={stepper} setStepper={setStepper} />
      )}
    </>
  );
};

const Container = styled.button<any>`
  display: flex;
  padding: 16px;
  align-items: center;
  /* justify-content: center; */
  gap: 8px;
  border-radius: 12px;
  border: 0px solid transparent;
  height: 100px;
  background: linear-gradient(151deg, #fff 19.97%, #ff5e00 199.31%);
  box-shadow:
    0px 0px 4px 0px rgba(0, 0, 0, 0.04),
    0px 8px 16px 0px rgba(0, 0, 0, 0.08);

  .banner {
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: space-between;
    gap: 4px;
    align-items: flex-start;
    text-align: left;

    .banner-title {
      color: #1a2028;
      font-family: materialBold;
      font-size: 17px;
    }

    .banner-subtitle {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #404751;
      font-family: materialMedium;
      font-size: 11px;
      svg {
        width: 20px;
        height: 20px;
        ${props => props.locale === 'ar' && 'transform: rotate(180deg)'}
      }
    }
  }
`;

export default AffordabilityBanner;
